import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TOBOLanding = () => {
  const navigate = useNavigate();
  const [showSelectionModal, setShowSelectionModal] = useState(false);
  const [modalAction, setModalAction] = useState('login'); // 'login' or 'signup'

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    // Inject FontAwesome icons if not already present
    let faLink = document.getElementById('fa-stylesheet');
    if (!faLink) {
      faLink = document.createElement('link');
      faLink.id = 'fa-stylesheet';
      faLink.rel = 'stylesheet';
      faLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
      document.head.appendChild(faLink);
    }
  }, []);

  const openSelectionModal = (actionType) => {
    setModalAction(actionType);
    setShowSelectionModal(true);
  };

  return (
    <div className="landing-page-root">
      <style>{`
        :root{
          --blue:#0B7FFA;
          --blue-dark:#0A63D6;
          --blue-deep:#0656B8;
          --blue-light:#E7F3FF;
          --blue-lighter:#F3F9FF;
          --pink:#F0407F;
          --pink-dark:#D62E68;
          --pink-light:#FDEEF5;
          --pink-lighter:#FFF5FA;
          --navy:#1E2738;
          --navy-2:#161D2C;
          --ink:#14171F;
          --gray-700:#4B5566;
          --gray-500:#6B7280;
          --gray-400:#98A2B3;
          --gray-300:#D0D5DD;
          --gray-200:#E5E8EE;
          --gray-100:#F2F4F7;
          --gray-50:#F8F9FB;
          --white:#FFFFFF;
          --shadow-card:0 24px 48px -16px rgba(20,23,31,.14);
          --shadow-soft:0 10px 30px rgba(20,23,31,.08);
          --shadow-tiny:0 4px 14px rgba(20,23,31,.06);
        }
        .landing-page-root {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: var(--ink);
          background: linear-gradient(180deg, #D9EBFD 0%, #E6F3FE 15%, #EEF6FE 35%, #F4F9FE 60%, #F8FCFF 80%, #FFFFFF 100%);
          -webkit-font-smoothing: antialiased;
          overflow-x: hidden;
          width: 100%;
          min-height: 100vh;
        }
        .landing-page-root * { box-sizing: border-box; margin: 0; padding: 0; }
        .landing-page-root img { max-width: 100%; display: block; }
        .landing-page-root a { text-decoration: none; color: inherit; }
        .landing-page-root ul { list-style: none; }
        .landing-page-root button { font-family: inherit; cursor: pointer; }
        .landing-page-root .wrap { max-width: 1760px; width: 100%; margin: 0 auto; padding: 0 48px; }

        /* ===== Buttons ===== */
        .landing-page-root .btn {
          display: inline-flex; align-items: center; justify-content: center; gap: 10px;
          padding: 14px 28px; border-radius: 12px; font-weight: 700; font-size: 15px;
          border: none; white-space: nowrap; transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
        }
        .landing-page-root .btn:hover { transform: translateY(-2px); }
        .landing-page-root .btn-icon {
          display: inline-flex; align-items: center; justify-content: center;
          width: 22px; height: 22px; border-radius: 50%; background: rgba(255,255,255,.25); font-size: 11px;
          flex-shrink: 0;
        }
        .landing-page-root .btn-blue { background: linear-gradient(135deg,#1E90FF,#0B7FFA); color: #fff; box-shadow: 0 10px 24px -8px rgba(11,127,250,.55); }
        .landing-page-root .btn-blue .btn-icon { background: rgba(255,255,255,.28); }
        .landing-page-root .btn-blue:hover { box-shadow: 0 14px 30px -8px rgba(11,127,250,.65); }
        .landing-page-root .btn-pink { background: linear-gradient(135deg,#F0508C,#E23478); color: #fff; box-shadow: 0 10px 24px -8px rgba(240,64,127,.5); }
        .landing-page-root .btn-pink .btn-icon { background: rgba(255,255,255,.28); }
        .landing-page-root .btn-pink:hover { box-shadow: 0 14px 30px -8px rgba(240,64,127,.6); }
        .landing-page-root .btn-white { background: #fff; color: var(--ink); border: 1.5px solid var(--gray-200); }
        .landing-page-root .btn-white:hover { border-color: var(--blue); color: var(--blue); }
        .landing-page-root .btn-outline { background: #fff; color: var(--ink); border: 1.5px solid var(--gray-200); }
        .landing-page-root .btn-outline .btn-icon { background: var(--gray-100); color: var(--ink); }
        .landing-page-root .btn-sm { padding: 10px 20px; font-size: 14px; border-radius: 10px; }

        /* ===== Header ===== */
        .landing-page-root .site-header {
          position: sticky; top: 0; z-index: 100;
          padding: 22px 0;
          backdrop-filter: blur(14px);
          background: rgba(217, 235, 253, 0.85);
          border-bottom: 1px solid rgba(11,127,250,0.08);
        }
        .landing-page-root .site-header .wrap { display: flex; align-items: center; justify-content: space-between; }
        .landing-page-root .logo { font-size: 28px; font-weight: 900; letter-spacing: .5px; }
        .landing-page-root .logo-blue { color: var(--blue); }
        .landing-page-root .logo-pink { color: var(--pink); }
        .landing-page-root .header-actions { display: flex; align-items: center; gap: 14px; }

        /* ===== Hero ===== */
        .landing-page-root .hero-section {
          position: relative;
          background: transparent;
          padding-bottom: 0;
          overflow: hidden;
        }
        .landing-page-root .hero-bg-blobs { display: none; }
        .landing-page-root .hero-inner {
          position: relative; z-index: 2;
          display: grid; grid-template-columns: 1.05fr 0.95fr; align-items: center;
          min-height: 560px;
          gap: 40px;
          padding-top: 48px;
          padding-bottom: 64px;
        }
        /* Left — text column */
        .landing-page-root .hero-text-col {
          display: flex; flex-direction: column; justify-content: center;
          background: transparent;
        }
        .landing-page-root .eyebrow {
          display: inline-block; font-size: 12px; font-weight: 800; letter-spacing: 1.6px;
          margin-bottom: 18px; text-transform: uppercase;
        }
        .landing-page-root .eyebrow-blue { color: #0B7FFA; }
        .landing-page-root .hero-title {
          font-size: 56px; line-height: 1.08; font-weight: 900; letter-spacing: -1.4px; color: #14171F;
          margin-bottom: 20px;
        }
        .landing-page-root .hero-title span {
          display: inline !important; font-size: inherit !important; line-height: inherit !important;
          margin: 0 !important; font-weight: inherit !important;
        }
        .landing-page-root .c-blue { color: #0B7FFA; }
        .landing-page-root .c-pink { color: #F0407F; }
        .landing-page-root .hero-sub {
          font-size: 17px; line-height: 1.65; color: #3A4252; max-width: 500px; margin-bottom: 34px; font-weight: 400;
        }
        .landing-page-root .hero-ctas { display: flex; gap: 14px; margin-bottom: 36px; flex-wrap: wrap; }
        .landing-page-root .hero-features { display: flex; align-items: center; gap: 24px; flex-wrap: wrap; }
        .landing-page-root .hero-features li {
          display: flex; align-items: center; gap: 7px; font-size: 13.5px; font-weight: 600; color: #3A4252;
        }
        .landing-page-root .hero-features li i { color: #0B7FFA; font-size: 13px; }
        .landing-page-root .hero-features li:nth-child(3) i { color: #F0407F; }

        /* Right — image column */
        .landing-page-root .hero-img-col {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .landing-page-root .hero-img-col img {
          width: 100%;
          max-height: 520px;
          object-fit: contain;
          display: block;
          filter: drop-shadow(0 20px 30px rgba(11,127,250,0.12));
        }

        /* Responsive: stack vertically on tablet/mobile */
        @media (max-width: 900px) {
          .landing-page-root .hero-inner { grid-template-columns: 1fr; gap: 32px; padding-top: 32px; padding-bottom: 48px; }
          .landing-page-root .hero-img-col { order: 2; }
          .landing-page-root .hero-text-col { order: 1; }
          .landing-page-root .hero-title { font-size: 38px; }
        }
        @media (max-width: 640px) {
          .landing-page-root .hero-title { font-size: 32px; }
          .landing-page-root .hero-features { gap: 14px; }
        }

        /* ===== Logos strip ===== */
        .landing-page-root .logos-section { padding: 60px 0 50px; background: #ffffff; border-top: 1px solid #f0f2f6; }
        .landing-page-root .logos-label {
          text-align: center; font-size: 12px; font-weight: 800; letter-spacing: 1.8px; color: var(--blue); margin-bottom: 30px;
        }
        .landing-page-root .logos-row { display: flex; align-items: center; gap: 24px; }
        .landing-page-root .logo-arrow {
          width: 38px; height: 38px; border-radius: 50%; border: 1.5px solid var(--blue-light); background: #fff;
          display: flex; align-items: center; justify-content: center; color: var(--blue); font-size: 13px; flex-shrink: 0;
          transition: border-color .15s ease, background .15s ease;
        }
        .landing-page-root .logo-arrow:hover { border-color: var(--blue); background: var(--blue-light); }
        .landing-page-root .logos-track {
          flex: 1; display: flex; align-items: center; justify-content: space-between; gap: 48px;
          overflow-x: auto; scrollbar-width: none; -ms-overflow-style: none;
        }
        .landing-page-root .logos-track::-webkit-scrollbar { display: none; }
        .landing-page-root .logo-item {
          font-size: 16px; font-weight: 800; color: #b8c4d8; text-align: center; line-height: 1.15; letter-spacing: .5px;
          white-space: nowrap; flex-shrink: 0;
        }
        .landing-page-root .logo-item span { display: block; font-size: 13px; font-weight: 600; letter-spacing: 2px; }
        .landing-page-root .logo-serif { font-family: Georgia,'Times New Roman',serif; font-weight: 700; }
        .landing-page-root .logo-script { font-family: 'Brush Script MT',cursive; font-style: italic; font-weight: 400; font-size: 18px; text-transform: lowercase; }
        .landing-page-root .logo-script2 { font-family: 'Brush Script MT',cursive; font-style: italic; font-weight: 400; font-size: 26px; text-transform: lowercase; }
        .landing-page-root .logo-crown { display: flex; flex-direction: column; align-items: center; gap: 2px; }
        .landing-page-root .logo-crown i { font-size: 13px; margin-bottom: 2px; }

        /* ===== About ===== */
        .landing-page-root .about-section { padding: 80px 0 100px; }
        .landing-page-root .eyebrow-gray { color: #98a2b3; }
        .landing-page-root .about-grid { display: grid; grid-template-columns: 0.9fr 1.25fr; gap: 64px; align-items: start; }
        .landing-page-root .about-title {
          font-size: 42px; line-height: 1.25; font-weight: 800; letter-spacing: -1px; color: var(--ink);
        }
        .landing-page-root .dot-icon {
          display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 50%;
          background: var(--pink); color: #fff; font-size: 14px; vertical-align: -4px;
        }
        .landing-page-root .about-cards {
          display: grid; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: auto auto; gap: 20px;
        }
        .landing-page-root .a-card { border-radius: 24px; padding: 26px 26px; position: relative; }
        .landing-page-root .a-card-blue {
          grid-column: 1; grid-row: 1 / span 2; background: linear-gradient(180deg,#E8F3FF 0%,#DCEBFC 100%);
          display: flex; flex-direction: column; overflow: hidden; padding-bottom: 0; min-height: 420px;
          border: 1px solid rgba(11,127,250,0.15);
        }
        .landing-page-root .a-card-white { grid-column: 2; grid-row: 1; background: #fff; border: 1px solid var(--gray-200); }
        .landing-page-root .a-card-pink {
          grid-column: 3; grid-row: 1; background: linear-gradient(180deg,#FDEFF5 0%,#FCE4EE 100%);
          border: 1px solid rgba(240,64,127,0.15);
        }
        .landing-page-root .a-card-navy {
          grid-column: 3; grid-row: 2; background: var(--navy); position: relative; overflow: hidden; min-height: 160px;
          display: flex; flex-direction: column; justify-content: center;
        }
        .landing-page-root .a-num { font-size: 38px; font-weight: 900; letter-spacing: -1px; margin-bottom: 8px; }
        .landing-page-root .a-lbl { font-size: 15px; font-weight: 700; color: var(--ink); margin-bottom: 10px; line-height: 1.3; }
        .landing-page-root .a-desc { font-size: 13px; color: #6b7280; line-height: 1.5; }
        .landing-page-root .a-icon-group { display: flex; gap: 10px; margin-top: 20px; }
        .landing-page-root .user-badge {
          width: 42px; height: 42px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 16px; color: #fff;
        }
        .landing-page-root .user-badge.badge-blue { background: var(--blue); }
        .landing-page-root .user-badge.badge-pink { background: var(--pink); }
        .landing-page-root .user-badge.badge-navy { background: var(--navy); }

        .landing-page-root .a-avatars { display: flex; margin: 14px 0 14px; }
        .landing-page-root .a-avatars .avatar-icon {
          width: 34px; height: 34px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
          font-size: 14px; color: #fff; border: 2.5px solid #fff; margin-left: -8px; box-shadow: 0 2px 6px rgba(0,0,0,0.08);
        }
        .landing-page-root .a-avatars .avatar-icon:first-child { margin-left: 0; }
        .landing-page-root .avatar-icon.bg-blue { background: #0B7FFA; }
        .landing-page-root .avatar-icon.bg-pink { background: #F0407F; }
        .landing-page-root .avatar-icon.bg-navy { background: #1E2738; }
        .landing-page-root .avatar-icon.bg-gray { background: #6B7280; }

        .landing-page-root .a-quote { font-size: 12.5px; font-style: italic; color: #6b7280; line-height: 1.55; }
        .landing-page-root .a-lbl-w { font-size: 13px; font-weight: 600; color: #c3c9d6; margin-bottom: 6px; }
        .landing-page-root .a-num-w { font-size: 34px; font-weight: 900; color: #fff; letter-spacing: -.8px; }
        .landing-page-root .a-world { position: absolute; right: -10px; bottom: -6px; width: 78%; height: auto; opacity: .9; }

        /* ===== Dual feature cards ===== */
        .landing-page-root .dual-section { padding: 10px 0 100px; }
        .landing-page-root .dual-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 32px; }
        .landing-page-root .dual-card {
          border-radius: 32px; padding: 48px 48px 52px; position: relative; overflow: hidden;
        }
        .landing-page-root .dual-blue { background: linear-gradient(150deg,#EAF4FF 0%,#F4F9FF 60%); border: 1.5px solid rgba(11,127,250,0.2); }
        .landing-page-root .dual-pink { background: linear-gradient(150deg,#FDEFF6 0%,#FEF6FA 60%); border: 1.5px solid rgba(240,64,127,0.2); }
        .landing-page-root .pill {
          display: inline-block; font-size: 11.5px; font-weight: 800; letter-spacing: 1px; padding: 6px 16px;
          border-radius: 20px; margin-bottom: 20px;
        }
        .landing-page-root .pill-blue { background: #D9ECFF; color: var(--blue); }
        .landing-page-root .pill-pink { background: #FBD9E9; color: var(--pink); }
        .landing-page-root .dual-title { font-size: 34px; font-weight: 900; letter-spacing: -.6px; line-height: 1.25; color: var(--ink); margin-bottom: 16px; }
        .landing-page-root .dual-desc { font-size: 15px; color: #5b6472; line-height: 1.6; max-width: 480px; margin-bottom: 26px; }
        .landing-page-root .check-list { display: flex; flex-direction: column; gap: 12px; margin-bottom: 32px; }
        .landing-page-root .check-list li { font-size: 14.5px; font-weight: 600; color: #333c4d; display: flex; align-items: center; gap: 12px; }
        .landing-page-root .check-list li i { font-size: 12px; }
        .landing-page-root .check-blue li i { color: var(--blue); }
        .landing-page-root .check-pink li i { color: var(--pink); }

        .landing-page-root .dual-mock {
          margin-top: 36px; display: grid; grid-template-columns: 1fr 1fr; gap: 16px; width: 100%;
        }
        .landing-page-root .mini-card { background: #fff; border-radius: 18px; padding: 18px 20px; box-shadow: var(--shadow-tiny); border: 1px solid #f0f1f5; }
        .landing-page-root .mini-top { display: flex; justify-content: space-between; align-items: center; font-size: 12px; font-weight: 700; color: #6b7280; margin-bottom: 6px; }
        .landing-page-root .mini-val { font-size: 21px; font-weight: 800; color: var(--ink); }
        .landing-page-root .mini-delta { font-size: 11px; font-weight: 700; color: #16a34a; margin-bottom: 6px; }
        .landing-page-root .table-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; margin-top: 6px; }
        .landing-page-root .t-sq {
          aspect-ratio: 1; border-radius: 8px; background: #f4f6f9; border: 1px solid #e8ebf0; display: flex; align-items: center;
          justify-content: center; font-size: 11px; font-weight: 700; color: #8891a1;
        }
        .landing-page-root .t-sq.t-blue { background: var(--blue); color: #fff; border-color: var(--blue); }
        .landing-page-root .t-sq.t-pink { background: var(--pink); color: #fff; border-color: var(--pink); }

        .landing-page-root .cal-top { margin-bottom: 10px; }
        .landing-page-root .cal-top i { font-size: 9px; color: #98a2b3; }
        .landing-page-root .cal-strip { display: grid; grid-template-columns: repeat(7,1fr); gap: 2px; text-align: center; margin-bottom: 12px; }
        .landing-page-root .cal-strip div { font-size: 10.5px; font-weight: 700; color: #333c4d; padding: 4px 0; border-radius: 8px; display: flex; flex-direction: column; gap: 2px; }
        .landing-page-root .cal-strip small { font-size: 7px; font-weight: 600; color: #98a2b3; text-transform: uppercase; }
        .landing-page-root .cal-strip .cal-today { background: var(--pink); color: #fff; border-radius: 50%; }
        .landing-page-root .cal-strip .cal-today small { color: #ffe3ee; }
        .landing-page-root .appt-mini { display: flex; flex-direction: column; padding: 7px 0; border-top: 1px solid #f2f3f6; }
        .landing-page-root .appt-mini-time { font-size: 9.5px; font-weight: 700; color: var(--ink); }
        .landing-page-root .appt-mini-txt { font-size: 9px; color: #6b7280; }
        .landing-page-root .appt-mini-txt em { font-style: normal; color: #9aa2b1; }
        .landing-page-root .bookings-row { display: flex; gap: 34px; margin-top: 4px; }
        .landing-page-root .b-num { font-size: 20px; font-weight: 800; color: var(--ink); }
        .landing-page-root .b-lbl { font-size: 10px; color: #98a2b3; font-weight: 600; margin-top: 2px; }

        .landing-page-root .corner-deco {
          position: absolute; width: 110px; height: 110px; border-radius: 50%; display: flex; align-items: center; justify-content: center;
          font-size: 34px; opacity: .9;
        }
        .landing-page-root .corner-pizza { bottom: -32px; left: -32px; background: radial-gradient(circle,#ffe3c2,#ffcf8a); color: #d97b1f; }
        .landing-page-root .corner-brush { bottom: -32px; right: -32px; background: radial-gradient(circle,#ffd7ea,#ffb6d5); color: #c23f78; }

        /* ===== Stats bar ===== */
        .landing-page-root .stats-bar {
          background: linear-gradient(100deg, #0B7FFA 0%, #3B82F6 35%, #D64292 70%, #F0407F 100%);
          padding: 38px 32px; border-radius: 28px; max-width: 1760px; width: 100%; margin: 0 auto;
          box-shadow: 0 20px 40px -10px rgba(11,127,250,0.3); box-sizing: border-box;
        }
        .landing-page-root .stats-grid { display: grid; grid-template-columns: repeat(4,1fr); gap: 24px; }
        .landing-page-root .stat-item { display: flex; align-items: center; gap: 16px; color: #fff; }
        .landing-page-root .stat-ic {
          width: 50px; height: 50px; border-radius: 50%; background: rgba(255,255,255,.22); flex-shrink: 0;
          display: flex; align-items: center; justify-content: center; font-size: 20px;
        }
        .landing-page-root .stat-num { font-size: 24px; font-weight: 800; letter-spacing: -.3px; }
        .landing-page-root .stat-lbl { font-size: 13px; font-weight: 500; opacity: .92; margin-top: 1px; }

        /* ===== SEO & COMPARISON TABLE SECTION ===== */
        .landing-page-root .comparison-section {
          padding: 100px 0 70px;
          background: transparent;
        }
        .landing-page-root .comp-header {
          text-align: center; max-width: 860px; margin: 0 auto 54px;
        }
        .landing-page-root .comp-eyebrow {
          color: var(--blue); font-size: 13px; font-weight: 800; letter-spacing: 1.8px; text-transform: uppercase; margin-bottom: 14px; display: inline-block;
        }
        .landing-page-root .comp-title {
          font-size: 42px; font-weight: 900; letter-spacing: -1px; color: var(--ink); margin-bottom: 18px; line-height: 1.2;
        }
        .landing-page-root .comp-subtitle {
          font-size: 17px; color: #5b6472; line-height: 1.65; font-weight: 400;
        }
        .landing-page-root .comp-table-container {
          background: #ffffff;
          border-radius: 28px;
          box-shadow: 0 24px 50px -15px rgba(11,127,250,0.1);
          border: 1px solid var(--gray-200);
          overflow-x: auto;
          margin-bottom: 30px;
        }
        .landing-page-root table.comp-table {
          width: 100%; border-collapse: collapse; text-align: left; font-size: 15px;
        }
        .landing-page-root table.comp-table th,
        .landing-page-root table.comp-table td {
          padding: 20px 28px; border-bottom: 1px solid var(--gray-100); vertical-align: middle;
        }
        .landing-page-root table.comp-table th {
          background: #f9fafb; font-weight: 700; color: var(--ink); font-size: 14.5px;
        }
        .landing-page-root table.comp-table th.tobo-col-head {
          background: linear-gradient(180deg,#EBF4FF 0%,#FDF0F6 100%);
          border-left: 2px solid var(--blue); border-right: 2px solid var(--pink);
          text-align: center; color: var(--blue-deep);
        }
        .landing-page-root table.comp-table td.tobo-col-cell {
          background: #f8fbff; border-left: 2px solid rgba(11,127,250,0.15); border-right: 2px solid rgba(240,64,127,0.15);
          text-align: center; font-weight: 700; color: var(--ink);
        }
        .landing-page-root table.comp-table td.other-col-cell {
          text-align: center; color: #6b7280; font-size: 14px;
        }
        .landing-page-root .tobo-badge {
          display: inline-block; background: linear-gradient(135deg, var(--blue), var(--pink)); color: #fff; font-size: 10.5px; font-weight: 800;
          padding: 4px 12px; border-radius: 20px; margin-bottom: 6px; letter-spacing: 0.5px;
        }

        /* ===== CTA section ===== */
        .landing-page-root .cta-section { padding: 90px 0 80px; }
        .landing-page-root .cta-grid { display: grid; grid-template-columns: 0.85fr 1.15fr; gap: 54px; align-items: center; }
        .landing-page-root .cta-title { font-size: 42px; font-weight: 900; letter-spacing: -1.2px; line-height: 1.18; color: var(--ink); margin-bottom: 18px; }
        .landing-page-root .cta-desc { font-size: 16px; color: #5b6472; margin-bottom: 30px; max-width: 440px; line-height: 1.6; }
        .landing-page-root .cta-btns { display: flex; gap: 16px; margin-bottom: 24px; flex-wrap: wrap; }
        .landing-page-root .cta-checks { display: flex; gap: 24px; }
        .landing-page-root .cta-checks span { font-size: 13px; font-weight: 600; color: #5b6472; display: flex; align-items: center; gap: 8px; }
        .landing-page-root .cta-checks i { color: var(--blue); font-size: 11px; }

        .landing-page-root .cta-right { position: relative; display: grid; grid-template-columns: 1fr 1fr; gap: 20px; min-height: 360px; }
        .landing-page-root .cta-card { background: #fff; border-radius: 20px; box-shadow: var(--shadow-card); border: 1px solid #f0f1f5; padding: 24px; }
        .landing-page-root .invoice-card { grid-column: 1; grid-row: 1/span 2; align-self: center; }
        .landing-page-root .services-card { grid-column: 2; grid-row: 1; align-self: end; }
        .landing-page-root .overview-card { grid-column: 2; grid-row: 2; align-self: start; margin-top: -10px; }

        .landing-page-root .inv-top { display: flex; justify-content: space-between; align-items: center; font-size: 14px; font-weight: 700; color: var(--ink); margin-bottom: 16px; }
        .landing-page-root .inv-paid { background: #DDF6E4; color: #15A34A; font-size: 10.5px; font-weight: 700; padding: 4px 12px; border-radius: 20px; }
        .landing-page-root .inv-id { font-size: 11.5px; color: #98a2b3; font-weight: 600; margin-bottom: 14px; }
        .landing-page-root .inv-amount { font-size: 28px; font-weight: 800; color: var(--ink); margin-bottom: 18px; }
        .landing-page-root .inv-line { display: flex; justify-content: space-between; font-size: 13px; color: #6b7280; padding: 7px 0; border-top: 1px solid #f2f3f6; }
        .landing-page-root .inv-line.inv-total { font-weight: 800; color: var(--ink); font-size: 14px; }
        .landing-page-root .inv-dl {
          width: 100%; margin-top: 16px; padding: 12px; border-radius: 12px; border: 1px solid var(--gray-200); background: #fff;
          font-size: 13px; font-weight: 700; color: var(--ink); display: flex; align-items: center; justify-content: center; gap: 8px;
        }

        .landing-page-root .serv-top { font-size: 14px; font-weight: 700; color: var(--ink); margin-bottom: 16px; }
        .landing-page-root .serv-row { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
        .landing-page-root .serv-icon {
          width: 26px; height: 26px; border-radius: 50%; background: var(--blue-light); color: var(--blue);
          display: flex; align-items: center; justify-content: center; font-size: 12px; flex-shrink: 0;
        }
        .landing-page-root .serv-name { font-size: 11px; font-weight: 600; color: #333c4d; width: 70px; flex-shrink: 0; }
        .landing-page-root .serv-bar { flex: 1; height: 6px; background: #f0f1f5; border-radius: 6px; overflow: hidden; }
        .landing-page-root .serv-bar span { display: block; height: 100%; background: var(--pink); border-radius: 6px; }
        .landing-page-root .serv-num { font-size: 11px; font-weight: 700; color: #98a2b3; width: 20px; text-align: right; }

        .landing-page-root .ov-tabs { display: flex; gap: 8px; margin-bottom: 16px; }
        .landing-page-root .ov-tabs span { font-size: 10.5px; font-weight: 700; padding: 6px 14px; border-radius: 16px; color: #98a2b3; background: #f4f6f9; }
        .landing-page-root .ov-tabs .tab-active { background: var(--blue-light); color: var(--blue); }
        .landing-page-root .ov-top { font-size: 11.5px; font-weight: 700; color: #6b7280; margin-bottom: 6px; }
        .landing-page-root .ov-val { font-size: 22px; font-weight: 800; color: var(--ink); }
        .landing-page-root .ov-delta { font-size: 11px; font-weight: 700; color: #16a34a; margin: 4px 0 6px; }

        /* ===== Footer strip ===== */
        .landing-page-root .footer-strip { background: var(--gray-50); padding: 52px 0 64px; border-top: 1px solid var(--gray-100); }
        .landing-page-root .footer-grid { display: grid; grid-template-columns: repeat(5,1fr); gap: 28px; }
        .landing-page-root .f-item { display: flex; flex-direction: column; align-items: flex-start; gap: 14px; }
        .landing-page-root .f-ic {
          width: 42px; height: 42px; border-radius: 12px; background: var(--blue-light); color: var(--blue);
          display: flex; align-items: center; justify-content: center; font-size: 17px; flex-shrink: 0;
        }
        .landing-page-root .f-title { font-size: 14.5px; font-weight: 700; color: var(--ink); margin-bottom: 4px; }
        .landing-page-root .f-desc { font-size: 12.5px; color: #8891a1; line-height: 1.5; }

        /* ===== Business Selection Modal (Minimalist & Uncluttered) ===== */
        .landing-page-root .selection-modal-backdrop {
          position: fixed; inset: 0; z-index: 999;
          background: rgba(15, 23, 42, 0.6);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          display: flex; align-items: center; justify-content: center;
          padding: 20px;
          animation: fadeInModal 0.2s ease-out;
        }
        @keyframes fadeInModal {
          from { opacity: 0; transform: scale(0.96); }
          to { opacity: 1; transform: scale(1); }
        }
        .landing-page-root .selection-modal-card {
          background: #ffffff;
          border-radius: 24px;
          max-width: 580px;
          width: 100%;
          padding: 36px 32px;
          position: relative;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.18);
          border: 1px solid #E2E8F0;
        }
        .landing-page-root .selection-modal-close {
          position: absolute; top: 20px; right: 20px;
          width: 34px; height: 34px; border-radius: 50%;
          background: #F1F5F9; border: none; color: #64748B;
          display: flex; align-items: center; justify-content: center;
          font-size: 15px; transition: all 0.15s ease; cursor: pointer;
        }
        .landing-page-root .selection-modal-close:hover {
          background: #E2E8F0; color: #0F172A;
        }
        .landing-page-root .selection-options-grid {
          display: grid; grid-template-columns: 1fr 1fr; gap: 18px; margin-top: 24px;
        }
        .landing-page-root .selection-option-card {
          border-radius: 18px; padding: 26px 20px; text-align: center; cursor: pointer;
          transition: all 0.2s ease;
          display: flex; flex-direction: column; align-items: center; justify-content: space-between;
          border: 1.5px solid #E2E8F0;
        }
        .landing-page-root .option-restaurant {
          background: #FAFCFF;
        }
        .landing-page-root .option-restaurant:hover {
          transform: translateY(-4px);
          border-color: #0B7FFA;
          box-shadow: 0 12px 24px -6px rgba(11, 127, 250, 0.2);
        }
        .landing-page-root .option-salon {
          background: #FFFAFC;
        }
        .landing-page-root .option-salon:hover {
          transform: translateY(-4px);
          border-color: #F0407F;
          box-shadow: 0 12px 24px -6px rgba(240, 64, 127, 0.2);
        }
        .landing-page-root .option-icon {
          width: 52px; height: 52px; border-radius: 14px;
          display: flex; align-items: center; justify-content: center;
          font-size: 22px; margin-bottom: 14px; flex-shrink: 0;
        }
        .landing-page-root .option-icon.icon-blue {
          background: #0B7FFA; color: #fff;
        }
        .landing-page-root .option-icon.icon-pink {
          background: #F0407F; color: #fff;
        }
        .landing-page-root .selection-option-card h4 {
          font-size: 18px; font-weight: 700; color: #0F172A; margin: 0 0 6px; line-height: 1.2;
        }
        .landing-page-root .selection-option-card p {
          font-size: 12.5px; color: #64748B; line-height: 1.45; margin-bottom: 18px; font-weight: 400;
        }

        /* ===== Platform Highlights Strip ===== */
        .landing-page-root .highlights-section {
          padding: 44px 0; background: transparent; border-top: 1px solid rgba(11,127,250,0.08); border-bottom: 1px solid rgba(11,127,250,0.08);
        }
        .landing-page-root .highlights-grid {
          display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px;
        }
        .landing-page-root .hl-item {
          display: flex; align-items: center; gap: 14px; padding: 18px 20px;
          background: rgba(255,255,255,0.7); backdrop-filter: blur(10px); border-radius: 16px; border: 1px solid rgba(11,127,250,0.1);
          transition: transform .2s ease, border-color .2s ease;
        }
        .landing-page-root .hl-item:hover { transform: translateY(-2px); border-color: #0B7FFA; }
        .landing-page-root .hl-item i {
          font-size: 20px; color: #0B7FFA; width: 44px; height: 44px; border-radius: 12px;
          background: #e0f2fe; display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .landing-page-root .hl-item:nth-child(2) i { color: #F0407F; background: #fdeef5; }
        .landing-page-root .hl-item:nth-child(3) i { color: #8B5CF6; background: #f3e8ff; }
        .landing-page-root .hl-item:nth-child(4) i { color: #10B981; background: #d1fae5; }
        .landing-page-root .hl-item h4 { font-size: 14px; font-weight: 800; color: #0F172A; margin-bottom: 3px; }
        .landing-page-root .hl-item p { font-size: 11.5px; color: #64748B; line-height: 1.35; font-weight: 500; }

        .landing-page-root .a-feature-pills {
          display: flex; flex-direction: column; gap: 8px; margin-top: 20px;
        }
        .landing-page-root .a-pill-item {
          display: flex; align-items: center; gap: 10px; padding: 10px 14px;
          background: rgba(255,255,255,0.9); border-radius: 10px; font-size: 12.5px;
          font-weight: 700; color: #0F172A; border: 1px solid rgba(11,127,250,0.12);
        }
        .landing-page-root .comp-table-container {
          width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch;
        }

        /* ===== Responsive ===== */
        @media (max-width:1280px){
          .landing-page-root .wrap{ padding: 0 32px; }
          .landing-page-root .hero-inner{ grid-template-columns: 1fr 1fr; gap: 24px; }
          .landing-page-root .dash-card{ width: 480px; }
          .landing-page-root .dual-mock{ grid-template-columns: 1fr; }
          .landing-page-root .highlights-grid{ grid-template-columns: repeat(2, 1fr); }
        }
        @media (max-width:980px){
          .landing-page-root .hero-inner{ grid-template-columns:1fr; text-align:left; }
          .landing-page-root .hero-right{ height:440px; margin-top:20px; }
          .landing-page-root .about-grid{ grid-template-columns:1fr; }
          .landing-page-root .about-cards{ grid-template-columns:1fr 1fr; }
          .landing-page-root .a-card-blue{ grid-column:1/-1; grid-row:auto; min-height:260px; }
          .landing-page-root .a-card-white{ grid-column:1; grid-row:auto; }
          .landing-page-root .a-card-pink{ grid-column:2; grid-row:auto; }
          .landing-page-root .a-card-navy{ grid-column:1/-1; grid-row:auto; }
          .landing-page-root .dual-grid{ grid-template-columns:1fr; }
          .landing-page-root .cta-grid{ grid-template-columns:1fr; }
          .landing-page-root .cta-right{ margin-top:20px; }
          .landing-page-root .stats-grid{ grid-template-columns:1fr 1fr; }
          .landing-page-root .footer-grid{ grid-template-columns:1fr 1fr; }
          .landing-page-root .selection-options-grid{ grid-template-columns: 1fr; }
        }
        @media (max-width:640px){
          .landing-page-root .wrap{ padding:0 16px; }
          .landing-page-root .hero-title{ font-size:32px; line-height:1.15; }
          .landing-page-root .about-title{ font-size:22px; line-height:1.25; }
          .landing-page-root .cta-title{ font-size:24px; line-height:1.2; }
          .landing-page-root .comp-title{ font-size:22px; line-height:1.2; }
          .landing-page-root .highlights-grid{ grid-template-columns: 1fr; gap: 12px; }
          .landing-page-root .hl-item{ padding: 14px 16px; }
          .landing-page-root .about-cards{ grid-template-columns:1fr; }
          .landing-page-root .a-card-blue,.landing-page-root .a-card-white,.landing-page-root .a-card-pink,.landing-page-root .a-card-navy{ grid-column:1; grid-row:auto; }
          .landing-page-root .cta-right{ grid-template-columns:1fr; }
          .landing-page-root .invoice-card,.landing-page-root .services-card,.landing-page-root .overview-card{ grid-column:1; grid-row:auto; margin-top:0; }
          .landing-page-root .stats-bar{ width: calc(100% - 32px); margin: 0 16px; padding: 28px 20px; border-radius: 20px; box-sizing: border-box; }
          .landing-page-root .stats-grid{ grid-template-columns: 1fr; gap: 20px; }
          .landing-page-root .footer-grid{ grid-template-columns:1fr; }
          .landing-page-root .hero-features{ gap:12px; }
          .landing-page-root .hero-ctas{ width:100%; flex-direction:column; }
          .landing-page-root .hero-ctas .btn{ width:100%; justify-content:center; }
        }
      `}</style>

      {/* ================= HERO & HEADER ================= */}
      <section className="hero-section">
        <div className="hero-bg-blobs" aria-hidden="true"></div>

        <header className="site-header">
          <div className="wrap">
            <a href="/" className="logo">
              <span className="logo-blue">TO</span><span className="logo-pink">BO</span>
            </a>
            <div className="header-actions">
              <button className="btn btn-white btn-sm" onClick={() => openSelectionModal('login')}>Login</button>
              <button className="btn btn-pink btn-sm" onClick={() => openSelectionModal('signup')}>
                Get Started Free <span className="btn-icon"><i className="fa-solid fa-arrow-right"></i></span>
              </button>
            </div>
          </div>
        </header>

        <div className="wrap hero-inner">
          {/* LEFT — text content */}
          <div className="hero-text-col">
            <div className="eyebrow eyebrow-blue">ALL-IN-ONE BUSINESS PLATFORM</div>
            <h1 className="hero-title">
              <span className="c-blue">One</span> Platform.<br />
              <span className="c-pink">Two</span> Experiences.
            </h1>
            <p className="hero-sub">
              Smart billing, seamless bookings, and effortless management for Restaurants &amp; Salons.
            </p>
            <div className="hero-ctas">
              <button className="btn btn-blue" onClick={() => navigate('/restaurant/signin')}>
                Explore Restaurant Solution <span className="btn-icon"><i className="fa-solid fa-arrow-right"></i></span>
              </button>
              <button className="btn btn-pink" onClick={() => navigate('/salon/signin')}>
                Explore Salon Solution <span className="btn-icon"><i className="fa-solid fa-arrow-right"></i></span>
              </button>
            </div>
            <ul className="hero-features">
              <li><i className="fa-solid fa-bolt"></i> Easy to Use</li>
              <li><i className="fa-solid fa-chart-line"></i> Real-time Insights</li>
              <li><i className="fa-solid fa-shield-halved"></i> Secure &amp; Reliable</li>
              <li><i className="fa-solid fa-headset"></i> 24/7 Support</li>
            </ul>
          </div>

          {/* RIGHT — transparent background image */}
          <div className="hero-img-col">
            <img src="/landbg.png" alt="TOBO Platform" />
          </div>
        </div>
      </section>

      {/* ================= PLATFORM HIGHLIGHTS ================= */}
      <section className="highlights-section">
        <div className="wrap">
          <div className="highlights-grid">
            <div className="hl-item">
              <i className="fa-solid fa-file-invoice-dollar"></i>
              <div>
                <h4>Instant Billing &amp; KOT</h4>
                <p>Generate bills &amp; print KOTs in under 3 seconds</p>
              </div>
            </div>
            <div className="hl-item">
              <i className="fa-solid fa-calendar-days"></i>
              <div>
                <h4>Smart Appointment POS</h4>
                <p>Seamless slot booking for staff &amp; services</p>
              </div>
            </div>
            <div className="hl-item">
              <i className="fa-solid fa-chart-pie"></i>
              <div>
                <h4>Real-time Analytics</h4>
                <p>Track daily revenue, expenses &amp; GST reports</p>
              </div>
            </div>
            <div className="hl-item">
              <i className="fa-solid fa-cloud-arrow-up"></i>
              <div>
                <h4>100% Cloud Synced</h4>
                <p>Access your business data anywhere, anytime</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= ABOUT US ================= */}
      <section className="about-section" id="about">
        <div className="wrap about-grid">
          <div className="about-left">
            <p className="eyebrow eyebrow-gray">ABOUT TOBO PLATFORM</p>
            <h2 className="about-title">
              India's most reliable billing partner dedicated to building <span className="dot-icon"><i className="fa-solid fa-circle-nodes"></i></span> <span className="c-blue">smarter</span> and more <span className="c-pink">adaptive</span> businesses.
            </h2>
          </div>

          <div className="about-cards">
            <div className="a-card a-card-blue">
              <div className="a-num c-blue">120+</div>
              <div className="a-lbl">Businesses<br />Empowered</div>
              <p className="a-desc">Collaborating with top restaurant &amp; salon brands nationwide.</p>
              <div className="a-feature-pills">
                <div className="a-pill-item"><i className="fa-solid fa-bolt" style={{ color: '#F59E0B' }}></i> Instant KOT &amp; Bill Printing</div>
                <div className="a-pill-item"><i className="fa-solid fa-receipt" style={{ color: '#10B981' }}></i> Automated GST &amp; Reports</div>
                <div className="a-pill-item"><i className="fa-solid fa-calendar-check" style={{ color: '#0B7FFA' }}></i> Salon Booking Calendar</div>
              </div>
            </div>

            <div className="a-card a-card-white">
              <div className="a-num">100%</div>
              <div className="a-lbl">Commitment to<br />Seamless Billing</div>
              <div className="a-avatars">
                <span className="avatar-icon bg-blue"><i className="fa-solid fa-user-tie"></i></span>
                <span className="avatar-icon bg-pink"><i className="fa-solid fa-user"></i></span>
                <span className="avatar-icon bg-navy"><i className="fa-solid fa-user-large"></i></span>
                <span className="avatar-icon bg-gray"><i className="fa-solid fa-users"></i></span>
              </div>
              <p className="a-quote">"TOBO's quick billing and instant KOT print completely transformed our daily operations. Fast, reliable, and super easy to use."</p>
            </div>

            <div className="a-card a-card-pink">
              <div className="a-num c-pink">520K+</div>
              <div className="a-lbl">Bills &amp; Orders<br />Processed</div>
              <p className="a-desc">Analyzed monthly to power smarter revenue &amp; inventory strategies.</p>
            </div>

            <div className="a-card a-card-navy">
              <div className="a-lbl-w">Cities Supported</div>
              <div className="a-num-w">20+</div>
              <svg className="a-world" viewBox="0 0 200 100" aria-hidden="true">
                <g fill="#3c4b6b">
                  <circle cx="10" cy="20" r="1.6"/><circle cx="18" cy="24" r="1.6"/><circle cx="26" cy="18" r="1.6"/><circle cx="34" cy="26" r="1.6"/><circle cx="42" cy="20" r="1.6"/><circle cx="50" cy="28" r="1.6"/><circle cx="58" cy="22" r="1.6"/><circle cx="66" cy="30" r="1.6"/><circle cx="74" cy="24" r="1.6"/><circle cx="82" cy="18" r="1.6"/><circle cx="90" cy="26" r="1.6"/><circle cx="98" cy="20" r="1.6"/><circle cx="106" cy="28" r="1.6"/><circle cx="114" cy="22" r="1.6"/><circle cx="122" cy="30" r="1.6"/><circle cx="130" cy="18" r="1.6"/><circle cx="138" cy="26" r="1.6"/><circle cx="146" cy="20" r="1.6"/><circle cx="154" cy="24" r="1.6"/><circle cx="162" cy="18" r="1.6"/><circle cx="170" cy="28" r="1.6"/><circle cx="178" cy="22" r="1.6"/><circle cx="186" cy="30" r="1.6"/>
                  <circle cx="14" cy="40" r="1.6"/><circle cx="22" cy="46" r="1.6"/><circle cx="30" cy="38" r="1.6"/><circle cx="38" cy="48" r="1.6"/><circle cx="46" cy="40" r="1.6"/><circle cx="54" cy="50" r="1.6"/><circle cx="62" cy="42" r="1.6"/><circle cx="70" cy="52" r="1.6"/><circle cx="78" cy="44" r="1.6"/><circle cx="86" cy="38" r="1.6"/><circle cx="94" cy="48" r="1.6"/><circle cx="102" cy="40" r="1.6"/><circle cx="110" cy="50" r="1.6"/><circle cx="118" cy="42" r="1.6"/><circle cx="126" cy="52" r="1.6"/><circle cx="134" cy="38" r="1.6"/><circle cx="142" cy="48" r="1.6"/><circle cx="150" cy="40" r="1.6"/><circle cx="158" cy="44" r="1.6"/><circle cx="166" cy="38" r="1.6"/><circle cx="174" cy="50" r="1.6"/><circle cx="182" cy="42" r="1.6"/>
                  <circle cx="20" cy="66" r="1.6"/><circle cx="28" cy="60" r="1.6"/><circle cx="36" cy="70" r="1.6"/><circle cx="44" cy="62" r="1.6"/><circle cx="52" cy="72" r="1.6"/><circle cx="60" cy="64" r="1.6"/><circle cx="68" cy="74" r="1.6"/><circle cx="76" cy="66" r="1.6"/><circle cx="84" cy="60" r="1.6"/><circle cx="92" cy="70" r="1.6"/><circle cx="100" cy="62" r="1.6"/><circle cx="108" cy="72" r="1.6"/><circle cx="116" cy="64" r="1.6"/><circle cx="124" cy="74" r="1.6"/><circle cx="132" cy="60" r="1.6"/><circle cx="140" cy="70" r="1.6"/><circle cx="148" cy="62" r="1.6"/><circle cx="156" cy="66" r="1.6"/><circle cx="164" cy="60" r="1.6"/><circle cx="172" cy="72" r="1.6"/><circle cx="180" cy="64" r="1.6"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* ================= RESTAURANT / SALON FEATURE CARDS ================= */}
      <section className="dual-section" id="industries">
        <div className="wrap dual-grid">

          <div className="dual-card dual-blue">
            <span className="pill pill-blue">FOR RESTAURANTS &amp; CAFES</span>
            <h3 className="dual-title">Run Your Restaurant<br /><span className="c-blue">Smarter with TOBO</span></h3>
            <p className="dual-desc">Manage KOTs, tables, digital menus, staff &amp; fast GST billing — all from one dashboard.</p>
            <ul className="check-list check-blue">
              <li><i className="fa-solid fa-check"></i> Instant KOT &amp; Table Management</li>
              <li><i className="fa-solid fa-check"></i> Digital Menu &amp; Inventory Control</li>
              <li><i className="fa-solid fa-check"></i> Kitchen &amp; Waiter Staff PINs</li>
              <li><i className="fa-solid fa-check"></i> Express Thermal &amp; GST Billing</li>
              <li><i className="fa-solid fa-check"></i> Live Sales &amp; GST Tax Reports</li>
            </ul>
            <button className="btn btn-blue" onClick={() => navigate('/restaurant/signin')}>
              Explore Restaurant Solution <span className="btn-icon"><i className="fa-solid fa-arrow-right"></i></span>
            </button>

            <div className="dual-mock">
              <div className="mini-card">
                <div className="mini-top"><span>Today's Sales</span></div>
                <div className="mini-val">₹45,680</div>
                <div className="mini-delta"><i className="fa-solid fa-arrow-up"></i> 12.5% vs yesterday</div>
                <svg viewBox="0 0 220 46" width="100%" height="40" preserveAspectRatio="none">
                  <polyline points="0,36 25,30 50,34 75,18 100,26 125,10 150,20 175,8 200,16 220,4"
                    fill="none" stroke="#0B7FFA" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className="mini-card">
                <div className="mini-top"><span>Table Overview</span></div>
                <div className="table-grid">
                  <span className="t-sq">01</span><span className="t-sq t-blue">02</span><span className="t-sq">03</span>
                  <span className="t-sq">04</span><span className="t-sq t-pink">05</span><span className="t-sq">06</span>
                </div>
              </div>
            </div>
            <div className="corner-deco corner-pizza"><i className="fa-solid fa-pizza-slice"></i></div>
          </div>

          <div className="dual-card dual-pink" id="salon">
            <span className="pill pill-pink">FOR SALONS &amp; SPAS</span>
            <h3 className="dual-title">Elevate Your Salon<br /><span className="c-pink">Experience with TOBO</span></h3>
            <p className="dual-desc">Streamline appointments, staff commissions, service catalog &amp; customer billing.</p>
            <ul className="check-list check-pink">
              <li><i className="fa-solid fa-check"></i> Easy Online &amp; In-Store Appointments</li>
              <li><i className="fa-solid fa-check"></i> Stylist Commission &amp; Attendance</li>
              <li><i className="fa-solid fa-check"></i> Client Profiles &amp; Service History</li>
              <li><i className="fa-solid fa-check"></i> Packages, Discounts &amp; Membership</li>
              <li><i className="fa-solid fa-check"></i> SMS &amp; WhatsApp Reminders</li>
            </ul>
            <button className="btn btn-pink" onClick={() => navigate('/salon/signin')}>
              Explore Salon Solution <span className="btn-icon"><i className="fa-solid fa-arrow-right"></i></span>
            </button>

            <div className="dual-mock">
              <div className="mini-card">
                <div className="mini-top cal-top"><i className="fa-solid fa-chevron-left"></i><span>May 2025</span><i className="fa-solid fa-chevron-right"></i></div>
                <div className="cal-strip">
                  <div><small>Sun</small>28</div><div><small>Mon</small>29</div><div><small>Tue</small>30</div>
                  <div><small>Wed</small>1</div><div><small>Thu</small>2</div><div className="cal-today"><small>Fri</small>3</div><div><small>Sat</small>4</div>
                </div>
                <div className="appt-mini"><span className="appt-mini-time">10:00 AM</span><span className="appt-mini-txt">Haircut &amp; Styling <em>with Priya</em></span></div>
                <div className="appt-mini"><span className="appt-mini-time">12:30 AM</span><span className="appt-mini-txt">Facial <em>with Neha</em></span></div>
              </div>
              <div className="mini-card bookings-card">
                <div className="mini-top"><span>Today's Bookings</span></div>
                <div className="bookings-row">
                  <div><div className="b-num">12</div><div className="b-lbl">Total Bookings</div></div>
                  <div><div className="b-num c-pink">8</div><div className="b-lbl">Completed</div></div>
                </div>
              </div>
            </div>
            <div className="corner-deco corner-brush"><i className="fa-solid fa-paintbrush"></i></div>
          </div>

        </div>
      </section>

      {/* ================= STATS BAR ================= */}
      <section className="stats-bar">
        <div className="wrap stats-grid">
          <div className="stat-item">
            <span className="stat-ic"><i className="fa-solid fa-user-group"></i></span>
            <div><div className="stat-num">10K+</div><div className="stat-lbl">Businesses Trust TOBO</div></div>
          </div>
          <div className="stat-item">
            <span className="stat-ic"><i className="fa-solid fa-arrow-trend-up"></i></span>
            <div><div className="stat-num">2M+</div><div className="stat-lbl">Transactions Processed</div></div>
          </div>
          <div className="stat-item">
            <span className="stat-ic"><i className="fa-solid fa-face-smile"></i></span>
            <div><div className="stat-num">98%</div><div className="stat-lbl">Customer Satisfaction</div></div>
          </div>
          <div className="stat-item">
            <span className="stat-ic"><i className="fa-solid fa-headset"></i></span>
            <div><div className="stat-num">24/7</div><div className="stat-lbl">Support Available</div></div>
          </div>
        </div>
      </section>

      {/* ================= SEO COMPARISON TABLE SECTION ================= */}
      <section className="comparison-section" id="comparison">
        <div className="wrap">
          <div className="comp-header">
            <span className="comp-eyebrow">BEST AFFORDABLE BILLING SYSTEM</span>
            <h2 className="comp-title">Why TOBO is India's #1 Rated Restaurant &amp; Salon Billing Software</h2>
            <p className="comp-subtitle">
              Compare TOBO against traditional legacy POS systems and manual paperwork. See why over 10,000+ business owners trust TOBO for maximum profits and zero hassle.
            </p>
          </div>

          <div className="comp-table-container">
            <table className="comp-table">
              <thead>
                <tr>
                  <th style={{ width: '34%' }}>Feature / Capabilities</th>
                  <th className="tobo-col-head" style={{ width: '24%' }}>
                    <span className="tobo-badge">⭐ BEST CHOICE</span>
                    <div>TOBO Billing POS</div>
                  </th>
                  <th style={{ width: '21%', textAlignment: 'center' }}>Legacy POS Software</th>
                  <th style={{ width: '21%', textAlignment: 'center' }}>Pen &amp; Paper / Excel</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Dual Mode: Salon &amp; Restaurant</strong><br /><small className="text-gray-400">Tailored UI for both food and beauty businesses</small></td>
                  <td className="tobo-col-cell"><i className="fa-solid fa-circle-check" style={{ color: '#0B7FFA', marginRight: '6px' }}></i> Included</td>
                  <td className="other-col-cell"><i className="fa-solid fa-circle-xmark" style={{ color: '#cbd5e1', marginRight: '6px' }}></i> Separate Purchase</td>
                  <td className="other-col-cell"><i className="fa-solid fa-circle-xmark" style={{ color: '#cbd5e1', marginRight: '6px' }}></i> Manual</td>
                </tr>
                <tr>
                  <td><strong>Affordability &amp; Pricing</strong><br /><small className="text-gray-400">Transparent pricing with zero hidden fees</small></td>
                  <td className="tobo-col-cell" style={{ color: '#F0407F' }}>#1 Most Affordable</td>
                  <td className="other-col-cell">Expensive Annual Lock-ins</td>
                  <td className="other-col-cell">High Errors &amp; Lost Revenue</td>
                </tr>
                <tr>
                  <td><strong>Cloud Instant Sync &amp; Backup</strong><br /><small className="text-gray-400">Access data anywhere on mobile, tablet or PC</small></td>
                  <td className="tobo-col-cell"><i className="fa-solid fa-circle-check" style={{ color: '#0B7FFA', marginRight: '6px' }}></i> Instant Real-Time</td>
                  <td className="other-col-cell"><i className="fa-solid fa-circle-xmark" style={{ color: '#cbd5e1', marginRight: '6px' }}></i> Local / Offline Only</td>
                  <td className="other-col-cell"><i className="fa-solid fa-circle-xmark" style={{ color: '#cbd5e1', marginRight: '6px' }}></i> Risk of Data Loss</td>
                </tr>
                <tr>
                  <td><strong>Quick KOT &amp; Salon Appointment Booking</strong><br /><small className="text-gray-400">Instant kitchen printing &amp; slot scheduling</small></td>
                  <td className="tobo-col-cell"><i className="fa-solid fa-circle-check" style={{ color: '#F0407F', marginRight: '6px' }}></i> Included</td>
                  <td className="other-col-cell">Extra Paid Module</td>
                  <td className="other-col-cell">Messy Registers</td>
                </tr>
                <tr>
                  <td><strong>WhatsApp &amp; Email Digital Receipts</strong><br /><small className="text-gray-400">Eco-friendly digital invoices sent to customers</small></td>
                  <td className="tobo-col-cell"><i className="fa-solid fa-circle-check" style={{ color: '#0B7FFA', marginRight: '6px' }}></i> Free &amp; Automatic</td>
                  <td className="other-col-cell"><i className="fa-solid fa-circle-xmark" style={{ color: '#cbd5e1', marginRight: '6px' }}></i> Paid Add-on</td>
                  <td className="other-col-cell"><i className="fa-solid fa-circle-xmark" style={{ color: '#cbd5e1', marginRight: '6px' }}></i> Hand-written Paper</td>
                </tr>
                <tr>
                  <td><strong>Role Security &amp; Staff PIN Controls</strong><br /><small className="text-gray-400">Admin, Manager &amp; Staff access levels</small></td>
                  <td className="tobo-col-cell"><i className="fa-solid fa-circle-check" style={{ color: '#F0407F', marginRight: '6px' }}></i> High Security</td>
                  <td className="other-col-cell">Complex Setup</td>
                  <td className="other-col-cell">No Security</td>
                </tr>
                <tr>
                  <td><strong>24/7 Priority Support</strong><br /><small className="text-gray-400">Instant call, chat &amp; email assistance</small></td>
                  <td className="tobo-col-cell"><i className="fa-solid fa-circle-check" style={{ color: '#0B7FFA', marginRight: '6px' }}></i> 24/7 Dedicated</td>
                  <td className="other-col-cell">Slow Email Response</td>
                  <td className="other-col-cell">No Support</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ================= CTA SECTION ================= */}
      <section className="cta-section" id="pricing">
        <div className="wrap cta-grid">
          <div className="cta-left">
            <p className="eyebrow eyebrow-gray">GET STARTED IN MINUTES</p>
            <h2 className="cta-title">Ready to <span className="c-pink">Transform</span><br />Your <span className="c-blue">Business</span> with TOBO?</h2>
            <p className="cta-desc">Join thousands of smart business owners running on TOBO Billing Software.</p>
            <div className="cta-btns">
              <button className="btn btn-blue" onClick={() => openSelectionModal('signup')}>Start Free Trial</button>
            </div>
            <div className="cta-checks">
              <span><i className="fa-solid fa-check"></i> No credit card required</span>
              <span><i className="fa-solid fa-check"></i> Cancel anytime</span>
            </div>
          </div>

          <div className="cta-right">
            <div className="cta-card invoice-card">
              <div className="inv-top"><span>Invoice</span><span className="inv-paid">Paid</span></div>
              <div className="inv-id">#INV-2025-001</div>
              <div className="inv-amount">₹2,450</div>
              <div className="inv-line"><span>Subtotal</span><span>₹2,100</span></div>
              <div className="inv-line"><span>Tax</span><span>₹210</span></div>
              <div className="inv-line inv-total"><span>Total</span><span>₹2,450</span></div>
              <button className="inv-dl"><i className="fa-solid fa-download"></i> Download Invoice</button>
            </div>

            <div className="cta-card services-card">
              <div className="serv-top">Top Services</div>
              <div className="serv-row">
                <span className="serv-icon"><i className="fa-solid fa-user-tie"></i></span>
                <span className="serv-name">Haircut</span>
                <div className="serv-bar"><span style={{ width: '90%' }}></span></div>
                <span className="serv-num">45</span>
              </div>
              <div className="serv-row">
                <span className="serv-icon"><i className="fa-solid fa-user"></i></span>
                <span className="serv-name">Hair Color</span>
                <div className="serv-bar"><span style={{ width: '65%' }}></span></div>
                <span className="serv-num">30</span>
              </div>
              <div className="serv-row">
                <span className="serv-icon"><i className="fa-solid fa-user-tie"></i></span>
                <span className="serv-name">Facial</span>
                <div className="serv-bar"><span style={{ width: '55%' }}></span></div>
                <span className="serv-num">25</span>
              </div>
              <div className="serv-row">
                <span className="serv-icon"><i className="fa-solid fa-user"></i></span>
                <span className="serv-name">Manicure</span>
                <div className="serv-bar"><span style={{ width: '44%' }}></span></div>
                <span className="serv-num">20</span>
              </div>
            </div>

            <div className="cta-card overview-card">
              <div className="ov-tabs"><span className="tab-active">Restaurant</span><span>Salon</span></div>
              <div className="ov-top"><span>Today's Overview</span></div>
              <div className="ov-val">₹45,680</div>
              <div className="ov-delta"><i className="fa-solid fa-arrow-up"></i> 12.5% vs yesterday</div>
              <svg viewBox="0 0 220 50" width="100%" height="44" preserveAspectRatio="none">
                <polyline points="0,40 25,32 50,36 75,20 100,28 125,12 150,22 175,10 200,18 220,6"
                  fill="none" stroke="#F0407F" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FOOTER FEATURE STRIP ================= */}
      <footer className="footer-strip">
        <div className="wrap footer-grid">
          <div className="f-item">
            <span className="f-ic"><i className="fa-solid fa-layer-group"></i></span>
            <div><div className="f-title">All-in-One POS System</div><div className="f-desc">Manage everything in one place from bookings to billing.</div></div>
          </div>
          <div className="f-item">
            <span className="f-ic"><i className="fa-solid fa-cloud"></i></span>
            <div><div className="f-title">Cloud-Based Access</div><div className="f-desc">Access your business data anytime, anywhere.</div></div>
          </div>
          <div className="f-item">
            <span className="f-ic"><i className="fa-solid fa-wand-magic-sparkles"></i></span>
            <div><div className="f-title">Smart Automation</div><div className="f-desc">Automate KOTs, appointments &amp; save valuable time.</div></div>
          </div>
          <div className="f-item">
            <span className="f-ic"><i className="fa-solid fa-lock"></i></span>
            <div><div className="f-title">Enterprise Data Security</div><div className="f-desc">Your data is safe with bank-grade encryption.</div></div>
          </div>
          <div className="f-item">
            <span className="f-ic"><i className="fa-solid fa-chart-line"></i></span>
            <div><div className="f-title">Scalable Growth</div><div className="f-desc">Built to scale seamlessly with multi-outlet growth.</div></div>
          </div>
        </div>
      </footer>

      {/* ================= BUSINESS TYPE SELECTION MODAL ================= */}
      {showSelectionModal && (
        <div className="selection-modal-backdrop" onClick={() => setShowSelectionModal(false)}>
          <div className="selection-modal-card" onClick={(e) => e.stopPropagation()}>
            <button className="selection-modal-close" onClick={() => setShowSelectionModal(false)} aria-label="Close modal">
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div style={{ textAlign: 'center', marginBottom: '22px' }}>
              <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#0F172A', letterSpacing: '-0.3px', margin: '0 0 6px' }}>
                Select Business Portal
              </h3>
              <p style={{ fontSize: '13.5px', color: '#64748B', margin: 0, fontWeight: '400' }}>
                Choose your industry to continue to your dedicated system.
              </p>
            </div>

            <div className="selection-options-grid">
              <div
                className="selection-option-card option-restaurant"
                onClick={() => {
                  setShowSelectionModal(false);
                  if (modalAction === 'signup') {
                    navigate('/restaurant/signup');
                  } else {
                    navigate('/restaurant/signin');
                  }
                }}
              >
                <div>
                  <div className="option-icon icon-blue">
                    <i className="fa-solid fa-utensils"></i>
                  </div>
                  <h4>Restaurant &amp; Cafe</h4>
                  <p>KOT billing, table management, digital menu &amp; GST POS.</p>
                </div>
                <button className="btn btn-blue btn-sm" style={{ width: '100%', marginTop: 'auto', borderRadius: '12px', height: '40px', fontSize: '13px', fontWeight: '700' }}>
                  {modalAction === 'login' ? 'Sign In' : 'Get Started'} <i className="fa-solid fa-arrow-right" style={{ marginLeft: '6px' }}></i>
                </button>
              </div>

              <div
                className="selection-option-card option-salon"
                onClick={() => {
                  setShowSelectionModal(false);
                  if (modalAction === 'signup') {
                    navigate('/salon/signup');
                  } else {
                    navigate('/salon/signin');
                  }
                }}
              >
                <div>
                  <div className="option-icon icon-pink">
                    <i className="fa-solid fa-scissors"></i>
                  </div>
                  <h4>Salon &amp; Spa</h4>
                  <p>Appointments, stylist commissions, packages &amp; customer billing.</p>
                </div>
                <button className="btn btn-pink btn-sm" style={{ width: '100%', marginTop: 'auto', borderRadius: '12px', height: '40px', fontSize: '13px', fontWeight: '700' }}>
                  {modalAction === 'login' ? 'Sign In' : 'Get Started'} <i className="fa-solid fa-arrow-right" style={{ marginLeft: '6px' }}></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TOBOLanding;